import { put, call } from 'redux-saga/effects';

function apiAdd(body){
    return body.addBranch({
        variables:{ 
            name: body.branch.name
        }
    })
}
  
export function* addBranch(action){
    try{
        const response = yield call(apiAdd, action.body);
        yield put({ type: "SUCCESS_ADD_BRANCH", payload: { data: response } });
    }catch(err){
        yield put({ type: "FAILURE_ADD_BRANCH" })
    }
}

function apiUpdate(body){
    return body.updateBranch({
        variables:{ 
            _id: body.branch._id, 
            name: body.branch.name
        }
    });
}

export function* updateBranch(action){
    try{
        const response = yield call(apiUpdate, action.body);
        yield put({ type: "SUCCESS_UPDATE_BRANCH", payload: { data: response } });
    }catch(err){
        yield put({ type: "FAILURE_UPDATE_BRANCH" })
    }
}

function apiRemove(body){
    return body.removeBranch({
        variables:{ 
            _id: body._id
        }
    });
}

export function* removeBranch(action){
    try{
        const response = yield call(apiRemove, action.body);
        yield put({ type: "SUCCESS_REMOVE_BRANCH", payload: { data: response } });
    }catch(err){
        yield put({ type: "FAILURE_REMOVE_BRANCH" })
    }
}


// WEBPACK FOOTER //
// ./src/store/sagas/branch.js